<template>
    <div v-if="config" class="top-hat" :class="modifierClass" aria-live="polite">
        <a class="top-hat__link" :href="config.link.url">
            {{ config.text }}
            <NebulaIcon :symbol-id="config.icon.name" class="top-hat__icon" />
        </a>
    </div>
</template>
<script setup>
import { NebulaIcon } from '@discoveryedu/nebula-components';
import topHatData from '@/data/educators/topHat';
import { computed } from 'vue';

const props = defineProps({
    source: {
        type: String,
        default: '',
        validator: (value) => ['content-connects', 'fin-lit-month', ''].includes(value),
    },
});

const config = computed(() => topHatData[props.source]);
const modifierClass = computed(() => (props.source ? `top-hat--${props.source}` : null));
</script>
<style lang="stylus">
.top-hat {
    align-content: center;
    background-color: $nebula-color-platform-neutral-500;
    font-weight: 700;
    height: 56px;
    margin: auto;
    padding: $nebula-space-1x;
    width: 100%;

    &__icon {
        color: $nebula-color-white;
        fill: $nebula-color-white;
        font-weight: 700;
        height: 12px;
    }

    &__link {
        align-items: center;
        color: $nebula-color-white;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: auto;
        text-align: center;
        text-decoration: none;
    }

    &:hover {
        background-color: $nebula-color-platform-neutral-400;
    }

    &--content-connects {
        background-color: #003d6b;

        &:hover {
            background-color: #0069B9;
        }
    }

    &--fin-lit-month {
        background-color: $nebula-color-success;

        &:hover {
            background-color: $nebula-color-success;
        }
    }
}
</style>
